import { ConfiguratorParams } from '@icc/shared/configurator-params';
import { Configurator } from './configurator';

export abstract class ConfiguratorConfigService {
    abstract configurator: (type: string, id: number, params: ConfiguratorParams, url?: string) => Configurator | Promise<Configurator>;
}
